import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import TDEECalculator from "../TDEECalculator";

const labelCls =
  "text-zinc-500 text-xs font-bold uppercase tracking-[0.15em]";
const inputCls =
  "mt-1 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white";

export default function AnamnesiPhysicalSection({ form, onChange, tdeeData }) {
  return (
    <>
      <p className="label-overline mb-3">DATI FISICI</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <div>
          <Label className={labelCls}>Altezza (cm)</Label>
          <Input
            type="number"
            value={form.height_cm}
            onChange={(e) => onChange("height_cm", e.target.value)}
            className={inputCls}
            data-testid="anamnesi-height_cm"
          />
        </div>
        <div>
          <Label className={labelCls}>Peso (kg)</Label>
          <Input
            type="number"
            value={form.weight_kg}
            onChange={(e) => onChange("weight_kg", e.target.value)}
            className={inputCls}
            data-testid="anamnesi-weight_kg"
          />
        </div>
        <div>
          <Label className={labelCls}>Livello Attivita</Label>
          <Select
            value={form.activity_level || "unset"}
            onValueChange={(v) => onChange("activity_level", v === "unset" ? "" : v)}
          >
            <SelectTrigger
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="anamnesi-activity_level"
            >
              <SelectValue placeholder="Seleziona" />
            </SelectTrigger>
            <SelectContent className="bg-[#171717] border-[#262626]">
              <SelectItem value="unset" className="text-white">-</SelectItem>
              <SelectItem value="sedentario" className="text-white">Sedentario</SelectItem>
              <SelectItem value="leggero" className="text-white">Leggero</SelectItem>
              <SelectItem value="moderato" className="text-white">Moderato</SelectItem>
              <SelectItem value="attivo" className="text-white">Attivo</SelectItem>
              <SelectItem value="molto_attivo" className="text-white">Molto Attivo</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <TDEECalculator
        tdeeData={tdeeData}
        activityLevel={form.activity_level}
        caloricStatus={form.caloric_status}
        onCaloricStatusChange={(v) => onChange("caloric_status", v)}
      />
    </>
  );
}
